<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title> Dados do registro </v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-12">
              <v-text-field
                label="Valor"
                v-model="current.value"
                outlined
                dense
              ></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: function () {
    return {
      current: null
    };
  },
  created: function () {
    this.load();
  },
  methods: {
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/permission/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.current = response.data;
          me.current.password = "";
        })
        .catch(function (error) {
          alert("Falha ao recuperar registro!");
          console.log(error);
        });
    },
    save: function () {
      var token = localStorage.getItem("token");
      if (this.current.id == 0) {
        api
          .post("/permission", this.current, {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function () {
            alert("Cadastrado com sucesso!");
            router.push({ path: "/permission" });
          })
          .catch(function (error) {
            alert("Falha ao criar registro!");
            console.log(error);
          });
      } else {
        api
          .put("/permission/" + this.current.id, this.current, {
            headers: { Authorization: "Bearer " + token },
          })
          .then(function () {
            alert("Atualizado com sucesso!");
            router.push({ path: "/permission" });
          })
          .catch(function (error) {
            alert("Falha ao editar registro!");
            console.log(error);
          });
      }
    },
  },
};
</script>